
module.config(function($stateProvider, $urlRouterProvider, $locationProvider) {

    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise("/");

    $stateProvider.state('site', {
        abstract: true,
        resolve: {
            _modelConfig: function(ModelConfig) {
                return ModelConfig.resolve();
            },
        },
    })

    .state('basic', {
        parent: 'site',
        abstract: true,
        resolve: {
            permissions: function(Principal) {
                return Principal.permissions;
            }
        },

        views: {
            '@': {
                templateUrl: "page/layouts/basic",
                controller: function($scope, Notifications) {
                    $scope.$notifications = Notifications.messages;
                },
            },
            'globalNav@basic': {
                templateUrl: "page/globalMenu",

            }
        }
    })

    .state('behind', {
        parent: 'basic',
        offcanvasHidden: true,
        views: {
            'behind@basic': {
                templateUrl: 'page/behind',
            },
        },
    })

    .state('error', {
        parent: 'basic',
        params: {statusCode: {}, data: {}},
        views: {
            'footer@basic': {
                controller: function($scope, $stateParams) {
                    $scope.statusCode = $stateParams.statusCode;
                },
                template: "<div class='status-code'>{{ statusCode }}</div>",
            },
            '': {
                controller: function($scope, $stateParams) {
                    $scope.statusCode = $stateParams.statusCode;
                    $scope.data = $stateParams.data;
                },
                templateUrl: 'page/error',
            }
        }
    })

    .state('home', {
        parent: 'basic',
        url: '/',
    });
});